module.exports = __webpack_public_path__ + "img/phone-bill-en.25946b74.jpg";